export const SetupRoutes = {
  path: "/setup",
  name: "Landing",
  redirect: "/",
  component: () => import("@/components/Installation/installationWrapper"),
  children: [
    {
      path: "/setup",
      name: "SETUP",
      redirect: "/setup/welcome",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "welcome",
          name: "Welcome",
          component: () => import("@/components/Installation/welcome")
        },
        {
          path: "activation-key",
          name: "Activation Key",
          component: () => import("@/components/Installation/activateKey")
        },
        {
          path: "enter-trial-key",
          name: "Enter Trial Key",
          component: () => import("@/components/Installation/enterTrialKey")
        },
        {
          path: "select-installation-type",
          name: "Select Installation Type",
          component: () =>
            import("@/components/Installation/selectInstallationType")
        },
        {
          path: "add-screens",
          name: "Add Screens",
          component: () => import("@/components/Installation/addScreens")
        },
        {
          path: "add-seat-layout",
          name: "Setup Add Seat Layout",
          component: () => import("@/components/Installation/addSeatLayout.vue")
        },
        {
          path: "price-master",
          name: "Price Master",
          component: () => import("@/components/Installation/priceMaster")
        },
        {
          path: "charge-settings",
          name: "Charge Settings",
          component: () => import("@/components/Installation/chargeSettings")
        },
        {
          path: "database-configuration",
          name: "Database Configuration",
          component: () =>
            import("@/components/Installation/databaseConfiguration")
        },

        {
          path: "backup-configuration",
          name: "Backup Configuration",
          component: () =>
            import("@/components/Installation/backupConfiguration")
        },
        {
          path: "setup-organization",
          name: "Organization Settings",
          props: true,
          component: () => import("@/components/Installation/setupOrganization")
        },
        {
          path: "add-cinema-master",
          name: "Add Cinemas",
          props: true,
          component: () => import("@/components/Installation/addCinema")
        },
        {
          path: "cinema-configuration",
          name: "Cinema Configuration",
          component: () =>
            import("@/components/Installation/cinemaConfiguration")
        },
        {
          path: "finance-configuration",
          name: "Finance Configuration",
          component: () =>
            import("@/components/Installation/financeConfiguration")
        },
        // CINEMA INSTALLATION
        // HO URL GENERATION
        {
          path: "cinema-url-installation",
          name: "Cinema URL Installation",
          component: () =>
            import("@/components/cinemaInstallation/cinemaUrlInstallation")
        },
        {
          path: "cinema-database-configuration",
          name: "Cinema Database Configuration",
          component: () =>
            import(
              "@/components/cinemaInstallation/cinemaDataBaseConfiguration"
            )
        },
        {
          path: "cinema-concession-levels",
          name: "Cinema Concession Levels",
          component: () =>
            import("@/components/cinemaInstallation/cinemaConcessionLevels")
        },

        {
          path: "concession-counters",
          name: "Concession Counters",
          component: () =>
            import("@/components/cinemaInstallation/concessionCounters")
        },
        {
          path: "database-configuration6",
          name: "Database Configuration 6",
          component: () =>
            import("@/components/cinemaInstallation/dataBaseConfiguration6")
        },
        {
          path: "setup-add-user",
          name: "Setup Add User",
          component: () =>
            import("@/components/cinemaInstallation/setupAddUser")
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/setupRoutes.js